export class AllValues {
    public realBs: number;
    public bsReal: number;
    public realDolar: number;
    public dolarReal: number;
    public bsDolar: number;
    public dolarBs: number;
}